import gsap from 'gsap';
import Swiper from 'swiper/bundle';
import {isTouch} from '../helpers/detect-device'

const touch = isTouch();
export default (scroller) => {

  if(document.querySelector('.card-slider__block-slider')){
    let scrollY = 0;
    let cursor = document.querySelector('#drag-cursor');

    scroller.on('scroll', (args) => {
      scrollY = args.delta.y - args.scroll.y;
    });

    let cardSliderBlocks = document.querySelectorAll('.card-slider__block');
    cardSliderBlocks.forEach((cardSliderBlock) => {
      let cardSliderContainer = cardSliderBlock.querySelector('.card-slider__block-slider');
      
      let isLoop = false;

      if(cardSliderContainer.classList.contains('latest-slider__block')){
        isLoop = true;
      }
      
      let cardSlidesPerViewMobile = 1;

      if(cardSliderBlock.classList.contains('category-slider__block')){
        cardSlidesPerViewMobile = 'auto';
      }

      let swiperCards = new Swiper(cardSliderContainer, {
        slidesPerView: cardSlidesPerViewMobile,
        loop: isLoop,
        navigation: {
          nextEl: cardSliderBlock.querySelector('.card-slider__button-next'),
          prevEl: cardSliderBlock.querySelector('.card-slider__button-prev'),
        },
        breakpoints: {
          641: {
            slidesPerView: 'auto',
            freeMode: true,
          }
        },
        on: {
					click: (swiper, e) => {
						if(touch) return;
						cardSliderContainer.style = 'pointer-events: none;'
						cursor.classList.add('drag-cursor--hidden');
            document.body.classList.remove('body--cursor-hidden');
					},
          touchMove: (swiper, e) => {
            moveCursor(cursor, e);
          },

          touchStart: (e) => {
            cursor.classList.add('drag-cursor--move');
          },

          touchEnd: (e) => {
            cursor.classList.remove('drag-cursor--move');
          }
        }
      });

      cardSliderContainer.addEventListener("pointerover", (e) => {
        cursor.classList.remove('drag-cursor--hidden');
        document.body.classList.add('body--cursor-hidden');
      });

      cardSliderContainer.addEventListener("pointerout", (e) => {
        cursor.classList.add('drag-cursor--hidden');
        document.body.classList.remove('body--cursor-hidden');
      });

      let cardContentContainer = document.querySelectorAll('.card__content-container');
      let articleCardRead = document.querySelectorAll('.article-card__read');

      if(cardContentContainer){
        cardContentContainer.forEach((content) => {
          content.addEventListener("pointermove", (e) => {
            cursor.classList.add('drag-cursor--hidden');
            document.body.classList.remove('body--cursor-hidden');
          });

          content.addEventListener("pointerover", (e) => {
            cursor.classList.add('drag-cursor--hidden');
            document.body.classList.remove('body--cursor-hidden');
          });
        });
      }

      if(articleCardRead){
        articleCardRead.forEach((content) => {
          content.addEventListener("pointermove", (e) => {
            cursor.classList.add('drag-cursor--hidden');
            document.body.classList.remove('body--cursor-hidden');
          });

          content.addEventListener("pointerover", (e) => {
            cursor.classList.add('drag-cursor--hidden');
            document.body.classList.remove('body--cursor-hidden');
          });
        });
      }

      document.addEventListener("mousemove", (e) => {
        moveCursor(cursor, e);
      });
    });

    function moveCursor(cursor, e){

      let cursorLeftPosition = e.clientX;
      let cursorTopPosition = e.clientY + scrollY;

      gsap.to(cursor, {
        x: cursorLeftPosition,
        y: cursorTopPosition, 
        ease: 'none', 
        duration: 0
      });
    }
  }
}
